import { useEffect } from 'react';
import { eventSubscription } from '../../../utils/events/eventSubscription';

export const GameWrapper = ({ children }) => {
  useEffect(
    () =>
      eventSubscription({
        callbacksBus: [
          {
            event: ['mousemove', 'touchmove', 'scroll'],
            callback(e) {
              e.preventDefault();
              global?.scrollTo(0, 0);
            },
          },
        ],
      }),
    [],
  );

  return children;
};
